// extracted by mini-css-extract-plugin
module.exports = {"button":"Button-module__button___1rxIF","disabled":"Button-module__disabled___1hUIS","withPadding":"Button-module__withPadding___3MkTV","primary":"Button-module__primary___zd-br"};